"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Spinner = function Spinner(props) {
  var _cx;

  var variant = props.variant,
      size = props.size;
  var spinnerClass = (0, _classnames.default)((_cx = {
    spinner: true
  }, _defineProperty(_cx, "spinner-".concat(variant), variant), _defineProperty(_cx, "spinner-".concat(size), size), _cx));
  return _react.default.createElement("div", {
    className: spinnerClass
  });
};

Spinner.propTypes = {
  size: _propTypes.default.string,
  variant: _propTypes.default.string
};
Spinner.defaultProps = {
  size: 'sm'
};
var _default = Spinner;
exports.default = _default;

//# sourceMappingURL=index.js.map